module.exports = __webpack_public_path__ + "static/Single-product-backlog-733f6ee5de4856c62b22c1f5aea2211b.jpg";